import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-books-dialog',
  templateUrl: './books-dialog.component.html',
  styleUrls: ['./books-dialog.component.css']
})
export class BooksDialogComponent implements OnInit {


  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<BooksDialogComponent>,@Inject(MAT_DIALOG_DATA ) public data: any,public router:Router) { }

  ngOnInit(): void {
  }

  close() {
    this.router.navigateByUrl('selfLearn-V2');
    this.dialogRef.close();
  }
  onBookSelect(book:any){
    this.dialogRef.close(book.id);
  }

}
